import React from 'react';
import { AlertTriangle, LucideProps } from 'lucide-react';

/**
 * Standardized Alert icon component.
 * Wraps the lucide-react AlertTriangle icon for consistent usage across the app.
 */
export const AlertIcon: React.FC<LucideProps> = (props) => {
  return <AlertTriangle {...props} />;
};
